export enum Combination {
  And = 'And',
  Or = 'Or'
}

export enum CombinationView {
  And = 'All',
  Or = 'Any'
}
